import { CLOSE_ICON, SEARCH_ICON } from '../utils.js';
// --------------------Append logo----------------------//

function appendLogo() {
  const mobileLogo = `<a href="/" aria-label="Home" class="mobile-logo"></a>`;
  $('.mobile-menu-header').prepend(mobileLogo);
  $('#mobileSearchInput').attr('placeholder', 'Search');
}

function appendCallLink() {
  const phoneTag = `<a href="tel:+14808165100" >Call +1 (480) 816-5100</a>`;
  $('.mobile-menu-footer-links').append(phoneTag);
}

function replaceCloseBtn() {
  const closeBtn = $('.close-mobile-menu');
  const closeIcon = CLOSE_ICON;
  closeBtn.html(closeIcon);
}

function replaceSearchIcon() {
  const searchBtn = $('.search-submit-btn');
  searchBtn.html(SEARCH_ICON);
}

// --------------------Mobile Menu Height Handler----------------------//
function updateMobileNavHeight(nav) {
  // check if the nav is at some deep level
  const hasLevelClass = nav.is('.show-level-2, .show-level-3, .show-level-4');

  if (!hasLevelClass) {
    // We go back to the first level → reset heights
    nav.css('height', 'auto');
    $('.mobile-menu-slider').css('height', 'auto');
    return;
  }

  // If there are active levels, find the deepest one
  const activeLevel = nav.find('ul.level-4-showing, ul.level-3-showing, ul.level-2-showing').last();

  const contHeight = activeLevel.length ? activeLevel.height() : nav.height();

  // Apply height to the nav
  nav.height(contHeight + 'px');
}

function fixMobileMenuHeight() {
  // Listen for clicks on next/prev level
  $(document).on('click', '.next-level-btn, .prev-level-btn', function () {
    const nav = $(this).closest('nav#mobile-nav');
    setTimeout(() => updateMobileNavHeight(nav), 310); // wait for animation
  });

  // Listen for opening/closing of the menu
  $(document).on('click', '.mobile-nav-toggle, .mobileNavLink', function () {
    const nav = $('#mobile-nav');
    setTimeout(() => updateMobileNavHeight(nav), 10);
  });
}

// --------------------Active Menu Item----------------------//

function highlightCurrentNav() {
  let currentUrl = window.location.href;
  while (currentUrl.endsWith('/')) {
    currentUrl = currentUrl.slice(0, -1);
  } // normalize by removing trailing "/"

  // clear previous states
  $('#mobile-nav a').removeClass('active active-parent');

  // find exact match
  const $currentLink = $(`#mobile-nav a[href="${currentUrl}"]`);

  if ($currentLink.length) {
    $currentLink.addClass('active');
    $currentLink.parents('li.has-subitems').children('a').addClass('active-parent');
  }
}

// --------------------Custom Mobile Menu----------------------//

function replaceNextLevelIcon() {
  const navMenu = $('.mobile-menu-slider');
  const nextLevelBtn = navMenu.find('.next-level-btn');
  nextLevelBtn.each((i, item) => {
    $(item).html('+');
  });
}

function modifyMobileMenu() {
  replaceNextLevelIcon();
  fixMobileMenuHeight();
  highlightCurrentNav();
}
// Mobile Menu Actions
$(document).ready(() => {
  const toggleBtn = $('.mobile-nav-toggle');
  appendLogo();
  appendCallLink();
  replaceCloseBtn();
  replaceSearchIcon();
  toggleBtn.on('click', () => {
    modifyMobileMenu();
  });
});
